import echarts from 'echarts';

const collectMoneyLineOptios = function collectMoneyLineOptios() {
  return {
    tooltip: {
      // 以下是悬浮的样式
      trigger: 'axis',
      backgroundColor: "#fff",
      textStyle: {
        color: "#FFAE00",
      },
      padding: [15, 30],
      extraCssText: 'box-shadow:0px 6px 21px 0px rgba(232,232,232,1);text-align:center',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#FFAE00',
          shadowBlur: 0,
        },
      },
      formatter(params) {
        return `${params[0].data}元<br>${params[0].name}`;
      },
    },
    dataZoom: {
      // type: 'inside',
      realtime: true, // 拖动滚动条时是否动态的更新图表数据
      height: 20, // 滚动条高度
      startValue: 0, // 数据窗口范围的起始数值
      endValue: 12,
      show: true,
      handleSize: 0, // 滑动条的 左右2个滑动条的大小
      zoomLock: true,
      bottom: 35, // 下面的距离
      fillerColor: 'rgba(233, 233, 233, 1)',
      showDataShadow: false, // 是否显示数据阴影 默认auto
      showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
      borderRadius: 5,
      filterMode: 'filter',
      // backgroundColor: '#33384b', // 两边未选中的滑动条区域的颜色
    },
    grid: {
      left: '2%',
      right: '4%',
      bottom: '10%',
      top: "8%",
      containLabel: true,
    },
    xAxis: [{
      type: 'category',
      boundaryGap: false,
      offset: 26,
      data: [],
    }],
    yAxis: [{
      type: 'value',
      offset: 15,
      axisPointer: {
        show: false,
      },
    }],
    series: [{
      name: '',
      type: 'line',
      stack: '总量',
      label: {
        normal: {
          show: true,
          position: 'top',
        },
      },
      data: [],
      itemStyle: {
        normal: {
          borderWidth: 3, // 拐点边框大小
          lineStyle: {
            width: 3,
            type: 'solid', // 'dotted'虚线 'solid'实线
          },
          areaStyle: {
            type: 'default',
            // 渐变色实现
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, // 变化度
              // 三种由深及浅的颜色
              [{
                offset: 0,
                color: '#FFF7E6',
              }, {
                offset: 1,
                color: '#fff',
              }]),
          },
        },
      },
    }],
  };
};

export default collectMoneyLineOptios;
